import loadingIcon from '../../src/assets/icon/loading.gif';
import Style from './FJLoading.module.less';
import classNames from 'classnames';

const FJLoading = props => {
    let { src, loading } = props;
    let URL = src ? src : loadingIcon.src;
    return (
        <div className={classNames(Style.icon_box, { [Style.icon_box_show]: loading })}>
            <img src={URL} alt='loading' width={22} height={22} />
        </div>
    );
};
export default FJLoading;
